import { useQuery, UseQueryResult } from "react-query";

import { GET_CUSTOMER_PHYSICIANS, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getCustomerPhysiciansAsync } from "api/customers";

interface Physician {
  id: number;
  physician_type: string;
  [key: string]: any;
}

interface UseGetCustomerPhysiciansReturn {
  physicians: Physician[];
  physiciansLoading: boolean;
  refetchPhysicians: () => void;
}

/**
 * The useGetCustomerPhysicians hook fetches the physicians/providers data for a given client.
 * @param clientId - The client ID.
 * @param extended - When true, requests the extended response (clinic + PHI release fields).
 */
const useGetCustomerPhysicians = (clientId?: string | number, extended = false): UseGetCustomerPhysiciansReturn & Omit<UseQueryResult, 'data' | 'isLoading' | 'refetch'> => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_CUSTOMER_PHYSICIANS, clientId, extended],
    () => getCustomerPhysiciansAsync(clientId, extended),
    {
      enabled: Boolean(clientId),
      staleTime: STALE_TIME_5_MINUTES,
      retry: false,
    }
  );

  return {
    physicians: data?.data || [],
    physiciansLoading: isLoading,
    refetchPhysicians: refetch,
    ...rest,
  };
};

export default useGetCustomerPhysicians;
